const styles = theme => ({
  root: {
    paddingLeft: 4,
    paddingRight: 16,
    display:'flex',
    '& a':{
      color: 'white',
      textDecoration: 'none',
      display: 'inline-block',
      marginRight:'10px',
    },
    '& span': {
      color:'white',
      display: 'inline-block',
      lineHeight: '24px',
      height: '24px',
    },
    '& p':{
      display:'inline-block',
      lineHeight: '24px',
      height: '24px',
    }
  },
  button: {
    backgroundColor: theme.palette.accent,
    color: 'white',
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/ui/back/styles.js